// extracted by mini-css-extract-plugin
export default {"container":"style_container__3XFzL","img":"style_img__flyRa","title":"style_title__ZeVTz","subtitle":"style_subtitle__SKYlK"};